module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Domi_480x480.576b9bf9.mp4";